module.exports = __webpack_public_path__ + "assets/img/ru-fabf389e.png";